// extracted by mini-css-extract-plugin
export default {"root":"styles_root__JCdku","icon":"styles_icon__i0SXh","tooltip":"styles_tooltip__wFhEr"};